var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sign-list" },
    [
      _c(
        "el-row",
        { staticClass: "row", attrs: { type: "flex", justify: "end" } },
        [
          _c(
            "el-col",
            { staticStyle: { "margin-right": "10px" }, attrs: { span: 8 } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", size: "small" },
                          model: {
                            value: _vm.selectedParm,
                            callback: function($$v) {
                              _vm.selectedParm = $$v
                            },
                            expression: "selectedParm"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "文件名称", value: "contractName" }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "签署方",
                              value: "signatoryFullName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        attrs: { size: "small", placeholder: "查询内容" },
                        model: {
                          value: _vm.selectedParmInfo,
                          callback: function($$v) {
                            _vm.selectedParmInfo = $$v
                          },
                          expression: "selectedParmInfo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          +_vm.$route.query.signStatus !== 5
            ? _c("el-col", { attrs: { span: 4 } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      "white-space": "nowrap"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "140px" },
                        attrs: { placeholder: "请选择", size: "small" },
                        model: {
                          value: _vm.selectedStatus,
                          callback: function($$v) {
                            _vm.selectedStatus = $$v
                          },
                          expression: "selectedStatus"
                        }
                      },
                      _vm._l(_vm.statusEnum, function(item, index) {
                        return _c("el-option", {
                          key: "status" + index,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 5 } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "unset" },
                attrs: {
                  type: "daterange",
                  "value-format": "yyyy-MM-dd",
                  "default-time": ["00:00:00", "23:59:59"],
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  size: "small"
                },
                model: {
                  value: _vm.datePikerArr,
                  callback: function($$v) {
                    _vm.datePikerArr = $$v
                  },
                  expression: "datePikerArr"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "text-right", attrs: { span: 3 } },
            [
              _c(
                "el-row",
                { attrs: { type: "flex" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.findScreenSign }
                        },
                        [_vm._v("查询")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small" }, on: { click: _vm.rest } },
                        [_vm._v("重置")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          key: "signlist-" + _vm.$route.query.signStatus,
          ref: "dataList",
          staticClass: "data-list",
          staticStyle: { "min-height": "54vh" },
          attrs: {
            data: _vm.tableList,
            "tooltip-effect": "dark",
            "expand-row-keys": _vm.expandKeys,
            "row-key": function(row) {
              return row.applyId
            },
            "header-cell-style": {
              background: "#f9f9f9",
              color: "#333333",
              fontWeight: "500"
            }
          },
          on: {
            "cell-mouse-enter": _vm.cellMouseEnter,
            "cell-mouse-leave": _vm.cellMouseLeave,
            "selection-change": _vm.handleSelectionChange
          }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", {
            attrs: { label: "文件名称", "min-width": "300" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          position: "relative",
                          "padding-top": "10px"
                        }
                      },
                      [
                        scope.row.files > 1
                          ? _c("span", { staticClass: "multiFile" }, [
                              _vm._v("多")
                            ])
                          : _vm._e(),
                        _c("corp-apply-name", {
                          attrs: {
                            applyType: "signList",
                            signInfo: {
                              fromDingTalk: scope.row.fromDingTalk || null,
                              signStatus: scope.row.signStatus,
                              selfSign: scope.row.selfSign,
                              selfApprove: scope.row.selfApprove,
                              signNo: scope.row.signNo,
                              contractName: scope.row.contractName,
                              applyNo: scope.row.applyNo,
                              approveId: scope.row.approveId,
                              multiFile: scope.row.multiFile,
                              aiCorpUserIdFlag: scope.row.aiCorpUserIdFlag
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c("p", { staticClass: "textEllipsis" }, [
                      _vm._v("发起方：" + _vm._s(scope.row.ebqUserName))
                    ]),
                    _c(
                      "p",
                      { staticClass: "textEllipsis" },
                      [
                        _vm._v(
                          "\n          发起时间：" +
                            _vm._s(
                              _vm._f("formatDateHM")(scope.row.createTime)
                            ) +
                            "\n          "
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              content: "由钉钉发起的",
                              placement: "bottom-start"
                            }
                          },
                          [
                            scope.row.fromDingTalk &&
                            scope.row.fromDingTalk == 1 &&
                            !_vm.isInDingTalk
                              ? _c("img", {
                                  attrs: {
                                    src: "/images/icon/dingIcon.png",
                                    alt: "钉钉",
                                    width: "20px"
                                  }
                                })
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "签署方", "min-width": "250" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-tooltip",
                      { attrs: { placement: "bottom-start" } },
                      [
                        _vm._l(scope.row.signInfoVOS, function(item, i) {
                          return _c(
                            "div",
                            {
                              key: i,
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                "padding-bottom": "5px"
                              },
                              attrs: { slot: "content" },
                              slot: "content"
                            },
                            [
                              item.orderNum && item.orderNum >= 1
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "block",
                                        width: "13px",
                                        height: "13px",
                                        "border-radius": "50%",
                                        color: "#ffffff",
                                        border: "1px solid #ffffff",
                                        "text-align": "center",
                                        "line-height": "13px",
                                        "font-size": "12px"
                                      }
                                    },
                                    [_vm._v(_vm._s(item.orderNum))]
                                  )
                                : _c(
                                    "span",
                                    { staticStyle: { color: "#ffffff" } },
                                    [_vm._v("·")]
                                  ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "#ffffff",
                                    "font-size": "12px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              【" +
                                      _vm._s(
                                        item.signStatus === 0 ||
                                          item.signStatus === -1
                                          ? "未签署"
                                          : item.signStatus === 1
                                          ? "已签署"
                                          : "已拒签"
                                      ) +
                                      "】\n            "
                                  )
                                ]
                              ),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    color: "#ffffff",
                                    "font-size": "12px"
                                  }
                                },
                                [_vm._v(_vm._s(item.signatoryFullName))]
                              )
                            ]
                          )
                        }),
                        _c(
                          "div",
                          [
                            _c("p", { staticClass: "textEllipsis" }, [
                              _vm._v(
                                _vm._s(
                                  scope.row.signInfoVOS[0].signatoryFullName
                                )
                              )
                            ]),
                            scope.row.signInfoVOS.length > 1
                              ? _c("p", { staticClass: "textEllipsis" }, [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.signInfoVOS[1].signatoryFullName
                                    )
                                  )
                                ])
                              : _vm._e(),
                            [
                              scope.row.signInfoVOS.length === 3
                                ? _c("p", { staticClass: "textEllipsis" }, [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.signInfoVOS[2]
                                          .signatoryFullName
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              scope.row.signInfoVOS.length > 3
                                ? _c("p", { staticClass: "textEllipsis" }, [
                                    _vm._v("···")
                                  ])
                                : _vm._e()
                            ]
                          ],
                          2
                        )
                      ],
                      2
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "状态", width: "100", "show-overflow-tooltip": "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.signStatus === -3
                      ? [
                          scope.row.selfApprove === 1
                            ? _c("span", { staticClass: "red" }, [
                                _vm._v("待我审")
                              ])
                            : _c("span", { staticClass: "blue" }, [
                                _vm._v("待ta审")
                              ])
                        ]
                      : scope.row.signStatus === -4
                      ? [_c("p", [_vm._v("审批驳回")])]
                      : scope.row.signStatus === 0
                      ? [
                          scope.row.selfSign === 1
                            ? _c("p", { staticClass: "red" }, [
                                _vm._v("待我签")
                              ])
                            : _c("p", { staticClass: "blue" }, [
                                _vm._v("待ta签")
                              ])
                        ]
                      : scope.row.signStatus === 1
                      ? [
                          _c("span", { staticClass: "green" }, [
                            _vm._v("已完成")
                          ])
                        ]
                      : scope.row.signStatus === 2
                      ? [
                          _c("span", { staticClass: "orange" }, [
                            _vm._v("已拒签")
                          ])
                        ]
                      : scope.row.signStatus === -5
                      ? [
                          _c("span", { staticClass: "grey" }, [
                            _vm._v("已撤销")
                          ])
                        ]
                      : scope.row.signStatus === -6
                      ? [
                          _c("span", { staticClass: "grey" }, [
                            _vm._v("已过期")
                          ])
                        ]
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "130px" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return !(
                      scope.row.applyNo && scope.row.applyNo.startsWith("APLO")
                    )
                      ? [
                          _c(
                            "div",
                            { staticClass: "operate-box pointer" },
                            [
                              scope.row.signStatus !== 1
                                ? _c("corp-handles", {
                                    ref: "handlesComp",
                                    attrs: {
                                      rowData: scope.row,
                                      applyType: "signList"
                                    },
                                    on: {
                                      setCSDialogData: _vm.onSetCSDialogData,
                                      setSSDialogData: _vm.onSetSSDialogData,
                                      resetList: _vm.getSignLists
                                    }
                                  })
                                : _vm._e(),
                              scope.row.signStatus === 1
                                ? [
                                    _c("existing-evidence", {
                                      attrs: { rowData: scope.row },
                                      on: {
                                        copyTextToQueryEmit: _vm.copyTextToQuery
                                      }
                                    }),
                                    _c(
                                      "el-dropdown",
                                      {
                                        attrs: { trigger: "click" },
                                        on: {
                                          "visible-change": function($event) {
                                            return _vm.visiChange(
                                              $event,
                                              scope.row.applyId
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "com-normal-btn" },
                                          [
                                            _vm._v(
                                              "\n                更多操作\n                "
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "com-normal-btn el-icon--right",
                                              class:
                                                _vm.visiDown.status &&
                                                _vm.visiDown.rowApplyId ==
                                                  scope.row.applyId
                                                  ? "el-icon-caret-top"
                                                  : "el-icon-caret-bottom"
                                            })
                                          ]
                                        ),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            staticStyle: {
                                              "background-color": "#f5f6f6"
                                            },
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown"
                                          },
                                          [
                                            _c("more-button", {
                                              attrs: {
                                                rowData: scope.row,
                                                showMoreBtn: true
                                              },
                                              on: {
                                                btnMethodFn: _vm.openLYDialog
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      : undefined
                  }
                }
              ],
              null,
              true
            )
          }),
          _c("no-data", {
            attrs: { slot: "empty", text: "暂无数据" },
            slot: "empty"
          })
        ],
        1
      ),
      _c(
        "el-row",
        {
          staticClass: "pageation row",
          style: { marginLeft: !_vm.$route.query.signStatus ? "70px" : 0 }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              ![4, 5].includes(+_vm.$route.query.signStatus)
                ? _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.batchDown } },
                    [_vm._v("下载")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.emitFn("saveToDir")
                    }
                  }
                },
                [_vm._v("归档")]
              ),
              !_vm.$route.query.ccToMe && false
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.selectCcUserFn()
                        }
                      }
                    },
                    [_vm._v("抄送")]
                  )
                : _vm._e(),
              _vm.$route.query.signStatus == 4 && false
                ? _c(
                    "el-tooltip",
                    { attrs: { effect: "dark" } },
                    [
                      _c(
                        "p",
                        {
                          staticStyle: { width: "200px", "line-height": "1.5" },
                          attrs: { slot: "content" },
                          slot: "content"
                        },
                        [
                          _vm._v("\n          批量签署规则：\n          "),
                          _c("br"),
                          _vm._v("1、当前签署方必须有固定签章位置\n          "),
                          _c("br"),
                          _vm._v("2、当前签署方不需要进行身份认证\n          "),
                          _c("br"),
                          _vm._v(
                            "3、当前签署方不包含强制阅读、强制现场\n          "
                          ),
                          _c("br"),
                          _vm._v("4、待ta签的合同不能进行批量签署\n        ")
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.batchSign }
                        },
                        [_vm._v("批量签署")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "page-flex-end", attrs: { span: 16 } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.screenParme.itemPage,
                  "pager-count": 5,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.screenParme.pageSize,
                  layout: "sizes, prev, pager, next, total",
                  total: _vm.screenParme.pageTotal
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange
                }
              }),
              _c("el-go", {
                attrs: {
                  "page-size": _vm.screenParme.pageSize,
                  total: _vm.screenParme.pageTotal
                },
                on: { "current-change": _vm.handleCurrentChange }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("tag-manage", {
        ref: "tagManage",
        attrs: { isCrop: true },
        on: { close: _vm.getTagList, refresh: _vm.getSignLists }
      }),
      _vm.cSDialogVisible
        ? _c("certiServiceDialog", {
            attrs: {
              dialogVisible: _vm.cSDialogVisible,
              listType: "corpList",
              param: _vm.cSDialogData
            },
            on: { setCSDialogData: _vm.onSetCSDialogData }
          })
        : _vm._e(),
      _vm.sSDialogVisible
        ? _c("selectSubjectDialog", {
            attrs: {
              dialogVisible: _vm.sSDialogVisible,
              param: _vm.sSDialogData
            },
            on: { setSSDialogData: _vm.onSetSSDialogData }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "ly-info",
          attrs: {
            title: "履约文件",
            visible: _vm.lYDialogVisible,
            width: "850px"
          },
          on: {
            "update:visible": function($event) {
              _vm.lYDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "ly-mask",
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c("el-tab-pane", { attrs: { label: "上传原文件", name: "1" } }, [
                _c("p", { staticClass: "tips" }, [
                  _vm._v(
                    "支持常见图片、文档、视频、音频、压缩包格式，上传后会保存原文件，单个文件大小不超过30MB"
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "box-wrap" },
                  [
                    _c("div", { staticClass: "temone add" }, [
                      _c("span", { staticClass: "el-icon-plus" }),
                      _c("input", {
                        ref: "referenceUpload",
                        staticClass: "file-ipt",
                        attrs: { type: "file" },
                        on: { change: _vm.handleInputChange }
                      })
                    ]),
                    _vm._l(_vm.lYDialogData, function(item, idx) {
                      return _c("div", { key: idx, staticClass: "temone" }, [
                        _c("div", { staticClass: "t-box" }, [
                          _c("img", {
                            staticClass: "y-img",
                            attrs: { src: "/images/web/file-icon.png" }
                          }),
                          _c("div", { staticClass: "msk" }, [
                            _c("span", { staticClass: "des" }, [
                              _vm._v(
                                "上传人：" +
                                  _vm._s(item.userName) +
                                  " -" +
                                  _vm._s(item.accountName)
                              )
                            ])
                          ])
                        ]),
                        _c("div", { staticClass: "a-btn" }, [
                          _c(
                            "a",
                            {
                              staticClass: "has-hover",
                              attrs: { href: _vm.downloadLYFile(item.file) }
                            },
                            [_vm._v("下载")]
                          ),
                          _vm.isDoc(item)
                            ? _c(
                                "a",
                                {
                                  staticClass: "has-hover",
                                  on: {
                                    click: function($event) {
                                      return _vm.previewDoc(item)
                                    }
                                  }
                                },
                                [_vm._v("预览")]
                              )
                            : _vm._e(),
                          _vm.isVideoOrImg(item)
                            ? _c(
                                "a",
                                {
                                  staticClass: "has-hover",
                                  on: {
                                    click: function($event) {
                                      return _vm.previewVideOrImg(item)
                                    }
                                  }
                                },
                                [_vm._v("预览")]
                              )
                            : _vm._e(),
                          item.canDelete
                            ? _c(
                                "a",
                                {
                                  staticClass: "has-hover",
                                  on: {
                                    click: function($event) {
                                      return _vm.delLYFile(item)
                                    }
                                  }
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                          _c("a", { staticClass: "no-hover" }, [
                            _vm._v(_vm._s(item.fileName))
                          ])
                        ])
                      ])
                    })
                  ],
                  2
                )
              ]),
              _c(
                "el-tab-pane",
                { attrs: { label: "上传文件哈希", name: "2" } },
                [
                  _c("p", { staticClass: "tips" }, [
                    _vm._v(
                      "格式没有限制，仅保存上传文件的特征值（哈希），不对文件本身做保存，单个文件大小不超过500M"
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "box-wrap" },
                    [
                      _c("div", { staticClass: "temone add" }, [
                        _c("span", { staticClass: "el-icon-plus" }),
                        _c("input", {
                          ref: "referenceUpload1",
                          staticClass: "file-ipt",
                          attrs: { type: "file" },
                          on: { change: _vm.handleInputChange }
                        })
                      ]),
                      _vm._l(_vm.lYDialogData, function(item, idx) {
                        return _c("div", { key: idx, staticClass: "temone" }, [
                          _c("div", { staticClass: "t-box" }, [
                            _c("img", {
                              staticClass: "y-img",
                              attrs: { src: "/images/web/hash-icon.png" }
                            }),
                            _c("div", { staticClass: "msk" }, [
                              _c("span", { staticClass: "des" }, [
                                _vm._v(
                                  "上传人：" +
                                    _vm._s(item.userName) +
                                    " -" +
                                    _vm._s(item.accountName)
                                )
                              ]),
                              _c("br"),
                              _c(
                                "span",
                                {
                                  staticClass: "des",
                                  staticStyle: { margin: "0" }
                                },
                                [_vm._v("备案号：" + _vm._s(item.presId))]
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "a-btn" }, [
                            _c(
                              "a",
                              {
                                staticClass: "has-hover",
                                on: {
                                  click: function($event) {
                                    return _vm.validLYFile(item)
                                  }
                                }
                              },
                              [_vm._v("验证")]
                            ),
                            item.canDelete
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "has-hover",
                                    on: {
                                      click: function($event) {
                                        return _vm.delLYFile(item)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                            _c("a", { staticClass: "no-hover" }, [
                              _vm._v(_vm._s(item.fileName))
                            ])
                          ])
                        ])
                      })
                    ],
                    2
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("span", { staticClass: "num" }, [
                _vm._v("\n        文件数：\n        "),
                _c("label", [_vm._v(_vm._s(_vm.lYDialogData.length))]),
                _vm._v("个\n      ")
              ]),
              _c(
                "el-button",
                {
                  staticClass: "cancel-btn",
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function($event) {
                      _vm.lYDialogVisible = false
                    }
                  }
                },
                [_vm._v("关闭")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("ViewFilesToDoc", {
        attrs: {
          visibleShow: _vm.visibleShowEnclosureDoc,
          enclosurePreviewNumItem: _vm.enclosurePreviewNumItem
        },
        on: { setViewFilesToDocDialogData: _vm.onSetViewFilesToDocDialogData }
      }),
      _c("ViewFilesToImg", {
        staticStyle: { "text-align": "center" },
        attrs: {
          visibleShow: _vm.visibleShowEnclosure,
          isRefresh: _vm.isRefresh,
          enclosurePreviewNumItem: _vm.enclosurePreviewNumItem,
          imgList: _vm.getEnclosureImgList
        },
        on: { setViewFilesToImgDialogData: _vm.onSetViewFilesToImgDialogData }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.nodeQueryVisible,
            width: "800px",
            "custom-class": "data-dialog",
            "destroy-on-close": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.nodeQueryVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "node_header",
              attrs: { slot: "title" },
              slot: "title"
            },
            [_vm._v("保全链节点查询")]
          ),
          _c("p", { staticStyle: { padding: "10px" } }, [
            _vm._v("当前合同备案号：" + _vm._s(_vm.vpresId))
          ]),
          _c("node-query", { attrs: { vpresId: _vm.vpresId } })
        ],
        1
      ),
      _c("selectCcUser", {
        ref: "selectCcUserRef",
        attrs: { applyNosArr: _vm.applyNosArr },
        on: { clearListFn: _vm.clearListFn }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "系统提示",
            visible: _vm.multiBatchDialogVisible,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.multiBatchDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "batch-tips" }, [
            _c("p", [
              _c("i", {
                staticClass: "el-icon-info",
                staticStyle: { "margin-right": "10px", "font-size": "20px" }
              }),
              _vm._v(
                "\n        确定使用以下印章，对 “" +
                  _vm._s(_vm.batchContractName) +
                  "” 等\n        " +
                  _vm._s(_vm.signInfoIdsLength) +
                  "\n        份文件中所有签章位置进行盖章（文件需要手写签字请勿使用此功能）？\n      "
              )
            ]),
            _c("p", [_vm._v("若印章使用时需要进行用印审批，不支持批量签署。")]),
            _c(
              "div",
              { staticClass: "temone-box" },
              _vm._l(_vm.chapterList, function(item, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "temone",
                    staticStyle: { margin: "10px" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "t-box",
                        class: {
                          "active-chap":
                            _vm.checkChapter &&
                            _vm.checkChapter.corpSealId === item.corpSealId
                        },
                        on: {
                          click: function($event) {
                            return _vm.checkUseChap(item)
                          }
                        }
                      },
                      [
                        item.hasOwnProperty("signUrl")
                          ? [
                              _c("img", {
                                staticClass: "y-img",
                                attrs: { src: item.signUrl }
                              })
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            item.hasOwnProperty("signUrl")
                              ? item.sealName + "(ID:" + item.corpSealId + ")"
                              : "系统图形章"
                          ) +
                          "\n          "
                      )
                    ])
                  ]
                )
              }),
              0
            )
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { color: "#1b1b1b", background: "#fff" },
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.multiBatchDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.batchSignAll }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b8287bd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b8287bd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/corp/signInfo/signListNew.vue
// module id = itFM
// module chunks = 27 31